/*
 * @Description 组件 报警消息
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<div class="view-message-box" v-resize="elFormResize">
		
		<template>
			<!-- iocn start -->
			<!--<i class="el-icon-message-solid message-box-icon"></i>-->
			<i v-if="voiceAllowFlag" @click="toggleVoiceFlag" class="iconfont el-icon-my_mn_shengyin_fill message-box-icon" :title="'声音已开启\n（点击可关闭声音）'"></i>
			<i v-else @click="toggleVoiceFlag" class="iconfont el-icon-my_mn_shengyinwu_fill message-box-icon" :title="'声音未开启\n（点击可开启声音）'"></i>
			<!-- iocn end -->
		</template>
		
		<!-- 系统时间 start -->
		<span class="abs-left t-0 b-0" style="height: 28px; line-height: 28px; padding: 0 10px;background-color: #05142c;left: 60px;font-size: 16px;">{{currentTime}}</span>
		<!-- 系统时间 end -->
		
		<!-- 容器 box start -->
		<div class="message-container-box">
			
			<!-- container-item start -->
			<div class="message-container-item" id="anchorBox">
				<!-- message-item-box start -->
				<span class="message-item-box msgItemBox" v-for="(item, index) in dataList" :key="index">
					{{item.text}}
				</span>
				<!-- message-item-box end -->
				<div v-if="$checkEmpty(dataList)" style="text-align: center;"></div>
			</div>
			<!-- container-item end -->
		</div>
		<!-- 容器 box end -->
		
		<audio id="audio" style="display: none;" cord_src="null" src="" muted="true" autoplay="autoplay"></audio>
		
	</div>
</template>

/* JS */
<script>
	// 引入组件 jQuery
	import $ from 'jquery'
	
	// API oam
	import ApiOam from '@/request/api-oam';
	// API 类型
	import ApiType from '@/request/api-type';
	// API 消息通知
	import ApiNotice from '@/request/api-notice';
	// 加载公共方法
	import GlobalParam from '@/global/global-param';
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "Messages",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        	
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				// 报警类型
				alarmStatus: [],
				// 报警 types
				alarms: [],
				// 报警 list
				alarmList: [],
				// 消息推送 list
				noticeList: [],
				
				// 数据列表
				dataList: [],
				// 主键 list
				keyList: [],
				// 新报警
				newLists: [],
				// 徐移除的 index list
				delKeys: [],
				// flag delekey
				delKeysFlag:false,
				// flag 允许播放声音
				voiceAllowFlag: this.$store.state.voiceAllowFlag==1,
				
				// elem anchorBox
				$anchorBox: '',
				// elem index
				rollIndex: 0,
				// 开始轮播
				rollStartFlag: false,
				// 正在轮播
				inRollFlag: false,
				// timer 轮播
				timer_roll: null,
				// 每轮播100px耗时
				rollPerSpeed: 2000,
				
				// elem audio
				$audio: '',
				// audio index
				audioIndex: 0,
				// flag audio roll
				audioRollFlag: false,
				// timer 播放声音
				timer_audio: null,
				// 延迟时间
				outTime_audio: 1000,
				outTime_audioE: 1500,
				
				currentTime: '',
				// 系统时间
				systemTime: null,
				
				// 信息弹窗 index
				firstNotifyIndex: 0,
				// 信息弹窗数量
				maxNotifyNUm: 1,
				// 记录数据
				cordList: [],
				// 记录数据 keys
				cordKeys: [],
				// notify list
				notifyList: [],
				// notify keys
				notifyKeys: [],
				// 记录notify
				notifyForm: {},
				// timer 轮播 notify
				timer_notify: null,
				// 轮播 延时
				outTime_notify: 5*1000,
				// timer 初始化
				timer_init_notify: null,
			}
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			// init elem
			this.initElem();
			
			// 开启订阅消息
			this.startSubscribes();
			
			
			// 初始化 轮播 elem
			//this.initElemRoll();
			// 轮播 开始
			//this.elemRoll();
			
			// 数据查询
			this.searchData();
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			// 取消订阅消息
			this.endSubscribes();
			// 关闭 timer
        	this.endTimers();
        	// 关闭信息弹窗
        	this.closeAllNotify();
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			/**
			 * @Des dom 尺寸更改
			 * @Auth
			 * @Date
			 */
			elFormResize(data) {
				// 初始化 轮播 elem
				if (!this.rollStartFlag || this.$checkEmpty(this.dataList)) {
					// 初始化 轮播 elem
					this.initElemRoll();
				};
				
				if (!this.$anchorBox.is(':visible')) {
					// 非首页 不展示
					
					// 记录notify
					if (!this.$checkEmpty(this.notifyForm)) {
						// 关闭信息弹窗
						this.closeAllNotify();
					}
				} else {
					// 首页 展示未展示项
					
					// 记录notify
					if(this.$checkEmpty(this.notifyForm) && !this.$checkEmpty(this.cordList)) {
						// 初始化 消息弹窗轮播
						this.initNotifyRollAge();
					}
				}
			},
			/**
        	 * @Des 关闭 timer
        	 * @Auth
        	 * @Date
        	 */
        	endTimers() {
        		// 清除计时器 轮播
                if (this.timer_roll != null) {
                	clearTimeout(this.timer_roll);
                	this.timer_roll = null;
                }
                // 清除计时器 播放声音
                if (this.timer_audio != null) {
                	clearTimeout(this.timer_audio);
                	this.timer_audio = null;
                }
                // timer 轮播 notify
				if (this.timer_notify != null) {
					clearTimeout(this.timer_notify);
					this.timer_notify = null;
				}
				// 清除计时器
				if (this.timer_init_notify != null) {
					clearInterval(this.timer_init_notify);
					// timer 初始化
					this.timer_init_notify = null;
				}
        	},
			//========================== 订阅消息 start ==========================
			/**
			 * @Des 开启订阅消息
			 * @Auth
			 * @Date
			 */
			startSubscribes() {
				// 订阅消息 报警改变
				this.sub_alarmChange = this.$pubsub.subscribe('AlarmChange', (name, data) => {
					// 数据查询 报警类型
					this.searchAlarmStatus();
				});
				// 订阅消息 消息通知
				this.sub_noticeChange = this.$pubsub.subscribe('AppNoticeChange', (name, data) => {
					// 查询 消息通知
					this.searchNotice();
				});
				
				// 订阅消息 系统时间
				this.sub_SystemTimeChange = this.$pubsub.subscribe('SystemTimeChange', (name, data) => {
					// 刷新 系统时间
					this.flushSystemTime(data);
				});
			},
			/**
			 * @Des 取消订阅消息
			 * @Auth
			 * @Date
			 */
			endSubscribes() {
				//取消订阅 报警改变
				this.$pubsub.unsubscribe(this.sub_alarmChange);
				//取消订阅 消息通知
				this.$pubsub.unsubscribe(this.sub_noticeChange);
				//取消订阅 系统时间
				this.$pubsub.unsubscribe(this.sub_SystemTimeChange);
			},
			
			//========================== 订阅消息 end ==========================
			
			/**
			 * @Des 刷新 系统时间
			 * @Auth 
			 * @Date 
			 */
			flushSystemTime(t) {
				// 空值 中止
				if (this.$checkEmpty(t)) return false;
				
				// 系统时间
				this.systemTime = t;
				
				// 当前时间
				this.searchCurrentTime(t);
			},
			
			//========================== 数据查询 start ==========================
			/**
			 * @Des 数据查询
			 * @Auth 
			 * @Date 
			 */
			searchData() {
				// 数据查询 报警类型
				this.searchAlarmStatus();
				// 查询消息通知
				this.searchNotice();
			},// searchData
			
			/**
			 * @Des 数据查询 报警类型
			 * @Auth 
			 * @Date 
			 */
			searchAlarmStatus() {
				this.$request.postJsonRequest(ApiType.findTypeApi, {
					projectId: this.$store.state.currentProjectId,
					type: "alarmTypes"
				}).then(result => {
					if(result.code == 0 && result.data.alarmTypes){
						// 数据列表
						this.alarmStatus = Object.assign([], []);
						// 报警 types
						let alarms = [];
						
						let alarmStatus = Object.assign([], result.data.alarmTypes);
						alarmStatus.forEach((row, index) => {
							// 数据列表
							this.alarmStatus.push({code: row.state,label: row.name,num: 0});
							// 报警 types
							alarms.push(row.state);
						});
						
						// 报警 types
						this.alarms = Object.assign([], alarms);
						
						// 数据查询 报警list
						this.searchAlarm();
					}
				}).catch(error => {
					console.error('查询报警类型异常', ApiType.findTypeApi, error);
				})
			},// searchAlarmStatus
			/**
			 * @Des 数据查询 报警list
			 * @Auth 
			 * @Date 
			 */
			searchAlarm() {
				this.$request.postJsonRequest(ApiOam.Search_Alarm_Uri, {
					projectId: this.$store.state.currentProjectId,
                    dealState: [1],// 0 预警	1 报警	2 已处理
                    alarms: this.alarms,
                    orderBy: {
                        alarm_date: 'desc'
                    },
                    total: 0,
                    startNum: 0,
                    limit: 0
				}).then(result => {
					// 报警 list
					this.alarmList = !this.$checkEmpty(result.rows) ? Object.assign([], result.rows) : [];
					
					// 数据 数据记录
					this.changeCordDate(Object.assign([], this.alarmList));
					
				}).catch(error => {
					console.error('查询报警数据异常', ApiOam.Search_Alarm_Uri, error);
				})
			},// searchAlarm
			
			/**
			 * @Des 查询消息通知
			 * @Auth 
			 * @Date 
			 */
			searchNotice() {
				this.$request.postJsonRequest(ApiNotice.searchNotice, {
					projectId: this.$store.state.currentProjectId,
				}).then(result => {
					// 消息推送 list
					this.noticeList = Object.assign([], result.data);
					// 数据改变
					this.changeListData(Object.assign([], this.noticeList));
				}).catch(error => {
					console.error('查询消息通知异常', ApiNotice.searchNotice, error);
				})
			},// searchNotice
			
			//========================== 数据查询 end ==========================
			
			/**
			 * @Des title 拼接
			 * @Auth
			 * @Date
			 */
			spliceTitle(row) {
				let title = row.label + '：' + row.num;
				return title;
			},
			
			/**
			 * @Des 允许/禁止 播放声音
			 * @Auth
			 * @Date
			 */
			toggleVoiceFlag() {
				// flag 允许播放声音
				this.voiceAllowFlag = !this.voiceAllowFlag;
				this.$store.dispatch("commitVoiceAllowFlag", this.voiceAllowFlag?1:0);
				
				if (this.voiceAllowFlag) {
					// 开启声音
					
				} else {
					// 关闭声音
					
					// 停止
					if(!this.$audio[0].paused){
						// flag audio roll
						this.$audio[0].pause();
					}
				}
				// 下一个 消息弹窗
				this.nextNotify();
				
				return false;
				// 声音轮播
				
				if (this.voiceAllowFlag) {
					// index audio
					this.audioIndex = this.rollIndex;
					
					// flag audio roll
					if (!this.audioRollFlag) {
						// 轮播 audio
						this.audioRoll();
					}
				} else {
					// 关闭声音
					
					// timer 播放声音
					if (this.timer_audio != null) {
						clearTimeout(this.timer_audio);
						this.timer_audio = null;
					}
					
					// 停止
					if(!this.$audio[0].paused){
						// flag audio roll
						this.$audio[0].pause();
					}
					this.audioRollFlag = false;
				}
			},
			
			/**
			 * @Des 初始化 elem变量
			 * @Auth
			 * @Date
			 */
			initElem() {
				// elem anchorBox
				this.$anchorBox = $('#anchorBox');
				// elem audio
				this.$audio = $('#audio');
			},
			
			//========================== 轮播 start ==========================
			/**
			 * @Des 初始化 轮播 elem
			 * @Auth
			 * @Date
			 */
			initElemRoll() {
				// 开始轮播
				this.rollStartFlag = true;
				
				// 清除定时器
				if (this.timer_roll != null) {
					clearTimeout(this.timer_roll);
					// timer 轮播
					this.timer_roll = null;
				}
				
				// 空值 中止
				if (this.$checkEmpty(this.dataList)) {
					// 开始轮播
					this.rollStartFlag = false;
					// 新位置
					this.$anchorBox.stop().css({'left': '0px'});
					return false;
				}
				
				// 未展示
				if (!this.$anchorBox.is(':visible')) {
					// 开始轮播
					this.rollStartFlag = false;
					// flag audio roll
					if (false && this.voiceAllowFlag && !this.audioRollFlag) {
						// 轮播 audio
						this.audioRoll();
					}
					return false;
				};
				
				// 移除已取消报警
				this.deleteOldRows();
				// 空值 重置 dom
				if (this.$checkEmpty(this.dataList)) {
					// 开始轮播
					this.rollStartFlag = false;
					// 新位置
					this.$anchorBox.stop().css({'left': '0px'});
					return false;
				}
				
				// 新位置
				this.$anchorBox.stop().css({'left': '100%'});
				
				// anchorBox parent
				let $anchorBoxParent = this.$anchorBox.parent();
				let anchorBoxParentL = parseInt($anchorBoxParent.outerWidth());
				// duration
				let duration = Math.ceil(Math.abs(anchorBoxParentL / 100 * this.rollPerSpeed));
				
				// 新位置
				this.$anchorBox.stop().animate({'left': '0px'}, duration, 'linear', () => {
					// timer 轮播
					this.timer_roll = setTimeout(() => {
						// 轮播 elem
						this.elemRoll();
					});
				});
				
				// flag audio roll
				if (false && this.voiceAllowFlag && !this.audioRollFlag) {
					// 轮播 audio
					this.audioRoll();
				}
			},
			/**
			 * @Des 轮播 elem
			 * @Auth
			 * @Date
			 */
			elemRoll() {
				// 清除定时器
				if (this.timer_roll != null) {
					clearTimeout(this.timer_roll);
					// timer 轮播
					this.timer_roll = null;
				}
				
				// elem index
				if (this.rollIndex >= this.dataList.length) {
					this.rollIndex = 0;
					
					// 正在轮播
					this.inRollFlag = false;
					
					// 初始化 轮播
					this.initElemRoll();
					return false;
				}
				
				// 正在轮播
				this.inRollFlag = true;
				
				// 当前 msg item
				let $msgItemBox = this.$anchorBox.find('.msgItemBox:eq('+ this.rollIndex +')');
				// 当前 宽度
				let msgItemBoxW = parseInt($msgItemBox.outerWidth());
				// duration
				let duration = Math.ceil(Math.abs(msgItemBoxW / 100 * this.rollPerSpeed));
				
				// anchorBox left
				let anchorBoxL = parseInt(this.$anchorBox.offset().left);
				let newLeft = parseInt(anchorBoxL - 300 - msgItemBoxW);
				
				// 轮播盒子
//				let anchorBoxW = this.$anchorBox.outerWidth();
//				// duration
//				let duration = Math.abs(parseInt(anchorBoxW / 100 * 1000));
//				let newLeft = -1 * anchorBoxW;
				
				// 新位置
				this.$anchorBox.stop().animate({'left': (newLeft + 'px')}, duration, 'linear', () => {
					// timer 轮播
					this.timer_roll = setTimeout(() => {
						// elem index
						this.rollIndex++;
						// 轮播 elem
						this.elemRoll();
					});
				});
				
			},
			//========================== 轮播 end ==========================
			
			//========================== 声音 start ==========================
			/**
			 * @Des 轮播 audio
			 * @Auth
			 * @Date
			 */
			audioRoll() {
				// timer 播放声音
				if (this.timer_audio != null) {
					clearTimeout(this.timer_audio);
					this.timer_audio = null;
				}
				
				// audio index
				if (this.audioIndex < 0 || this.audioIndex >= this.dataList.length) {
					this.audioIndex = 0;
				}
				// 空值 中止
				if (this.$checkEmpty(this.dataList)) return false;
				
				// flag 允许播放声音
				if (!this.voiceAllowFlag) return false;
				
				// 记录数据
				const row = Object.assign({}, this.dataList[this.audioIndex]); 
				
				// 空值 && 已经请求过 中止
				if (this.$checkEmpty(row.audioSrc)) {
					
					// 文字换换语音
					this.textToVoice();
					
					return false;
				}
				
				// 重置 src
				this.$audio.prop({'loop': false, 'muted': false}).attr({'src': row.audioSrc, 'cord_src': row.audioSrc});
				
				// 事件监听 audio 播放完毕
				this.$audio.off('ended').on('ended', () => {
					// timer 播放声音
					if (this.timer_audio != null) {
						clearTimeout(this.timer_audio);
						this.timer_audio = null;
					}
					// flag 允许播放声音
					if (!this.voiceAllowFlag) return false;
					
					// index audio roll
					this.audioIndex++;
					// timer 播放声音
					this.timer_audio = setTimeout(() => {
						// flag 允许播放声音
						if (!this.voiceAllowFlag) return false;
						
						// 轮播 audio
						this.audioRoll();
					}, this.outTime_audio);
				});
				
				// 监听出错
				this.$audio.off('error').on('error', () => {
					// timer 播放声音
					if (this.timer_audio != null) {
						clearTimeout(this.timer_audio);
						this.timer_audio = null;
					}
					// flag 允许播放声音
					if (!this.voiceAllowFlag) return false;
					
					// index audio roll
					this.audioIndex++;
					// timer 播放声音
					this.timer_audio = setTimeout(() => {
						// flag 允许播放声音
						if (!this.voiceAllowFlag) return false;
						
						// 轮播 audio
						this.audioRoll();
					}, this.outTime_audioE);
				});
				
				// flag audio roll
				this.audioRollFlag = true;
				
				// 静音
				this.$audio[0].muted = true;
				// 加载
				this.$audio[0].load();
				// 播放
				this.$audio[0].play();
				// 静音
				this.$audio[0].muted = false;
				
			},
			//========================== 声音 end ==========================
			
			//========================== 数据查询 start ==========================
			/**
			 * @Des 文字换换语音
			 * @Auth 
			 * @Date 
			 */
			textToVoice() {
				// flag delekey
				// if (this.delKeysFlag) return false;
				
				// flag 允许播放声音
				if (!this.voiceAllowFlag) return false;
				
				if (this.audioIndex < 0) {
					this.audioIndex = 0;
				}
				// 记录数据
				const row_record = Object.assign({}, this.dataList[this.audioIndex]);
				
				// 有语音 继续播放
				if (!this.$checkEmpty(row_record.audioSrc)) {
					// timer 播放声音
					if (this.timer_audio != null) {
						clearTimeout(this.timer_audio);
						this.timer_audio = null;
					}
					
					// timer 播放声音
					this.timer_audio = setTimeout(() => {
						// flag 允许播放声音
						if (!this.voiceAllowFlag) return false;
						
						// 轮播 audio
						this.audioRoll();
					}, this.outTime_audio);
					return false;
				}
				
				// 设置 apiKey
				this.$store.state.apiKey = '467da6edce4e831998edc7d9b7e215bfWN';
				this.$request.postJsonRequest(ApiOam.Text_To_Voice_Uri, {
					projectId: this.$store.state.currentProjectId,
					text: row_record.audioText
				}).then(result => {
					
					// timer 播放声音
					if (this.timer_audio != null) {
						clearTimeout(this.timer_audio);
						this.timer_audio = null;
					}
					
					// 数据对应 更改 audioSrc
					if (this.dataList[this.audioIndex].audioText == row_record.audioText) {
						this.dataList[this.audioIndex].audioSrc = "data:audio/wav;base64," + result.data;
						// flag 向后台交互
						this.dataList[this.audioIndex].getVoiceFlag = true;
					}
					
					
					// 设置 apiKey
					this.$store.state.apiKey = '';
					
					// flag 允许播放声音
					if (!this.voiceAllowFlag) return false;
					// timer 播放声音
					this.timer_audio = setTimeout(() => {
						// flag 允许播放声音
						if (!this.voiceAllowFlag) return false;
						
						// 轮播 audio
						this.audioRoll();
					}, this.outTime_audio);
					
				}).catch(error => {
					// 设置 apiKey
					this.$store.state.apiKey = '';
					
					// timer 播放声音
					if (this.timer_audio != null) {
						clearTimeout(this.timer_audio);
						this.timer_audio = null;
					}
					
					// 数据对应 更改 audioSrc
					if (this.dataList[this.audioIndex].audioText == row_record.audioText) {
						// flag 向后台交互
						this.dataList[this.audioIndex].getVoiceFlag = true;
					}
					
					// flag 允许播放声音
					if (!this.voiceAllowFlag) return false;
					// index audio roll
					this.audioIndex++;
					// timer 播放声音
					this.timer_audio = setTimeout(() => {
						// flag 允许播放声音
						if (!this.voiceAllowFlag) return false;
						
						// 轮播 audio
						this.audioRoll();
					}, this.outTime_audioE);
					
					console.error('文字转语音异常', ApiOam.Text_To_Voice_Uri, error);
				})
			},// textToVoice
			//========================== 数据查询 end ==========================
			
			//========================== 报警数据改变 start ==========================
			/**
			 * @Des 数据改变
			 * @Auth 
			 * @Date 
			 */
			changeListData(data) {
				
				// get 0 time
				let date = new Date();
				date.setHours(0,0,0,0);
				let time = date.getTime();

				// 新报警
				this.newLists = [];
				// 徐移除的 key list
				this.delKeys = [];
				
				// 新 keys
				let newKeys = [];
				// 遍历 数据
				data.forEach((row, index) => {
					// 空值 跳过
					if (this.$checkEmpty(row) || this.$checkEmpty(row.id)) return true;

					let formatT = '';
					if(new Date(row.alarmDate).getTime() - time < 0){
						formatT += 'YYYY-MM-DD';
					}
					formatT += ' HH:mm:ss';
					
					// msgText
					// row.msgText = this.$moment(row.alarmDate).format(formatT) + ' ' + row.bindingName + ' 触发了 ' + row.alarmName;
					// row.audioText = this.$moment(row.alarmDate).format(formatT) + row.bindingName + '触发了' + row.alarmName;
					
					// 主键
					let key = row.id;
					// 新 keys
					newKeys.push(key);
					
					// 移除当前val
					let delIndex = this.delKeys.indexOf(key);
					delIndex != -1 && this.delKeys.splice(delIndex, 1);
					
					// 主键 list
					if (this.keyList.indexOf(key) == -1) {
						// 数据 list
						this.dataList.push(Object.assign({}, row));
						// 主键 list
						this.keyList.push(row.id);
					}
				});
				
				// 遍历 keyList
				Object.assign([], this.keyList).forEach((val, index) => {
					// 空值 跳过
					if (this.$checkEmpty(val)) return true;
					
					if (newKeys.indexOf(val) == -1) {
						// 报警已取消
						// 徐移除的 key list
						this.delKeys.push(val);
					}
				});
				
				// 移除已取消报警
				this.deleteOldRows();
				
				// 初始化 轮播 elem
				if (!this.rollStartFlag || this.$checkEmpty(this.dataList)) {
					// 初始化 轮播 elem
					this.initElemRoll();
				};
			},
			/**
			 * @Des 移除已取消报警
			 * @Auth 
			 * @Date 
			 */
			deleteOldRows() {
				// flag delekey
				this.delKeysFlag = true;
				
				// 移除旧报警
				Object.assign([], this.delKeys).forEach((val, index) => {
					// 空值 跳过
					if (this.$checkEmpty(val)) return true;
					
					let oIndex = this.keyList.indexOf(val);
					
					// key 不存在 跳过
					if (oIndex == -1) return true;
					
					// 目标数据非空 正在轮播项 && 之前 跳过
					if (!this.$checkEmpty(this.noticeList) && this.inRollFlag && oIndex <= this.rollIndex) return true;
					
					// 移除 dataList
					this.dataList.splice(oIndex, 1);
					// 移除 keyList
					this.keyList.splice(oIndex, 1);
					
					// 比较当前轮播项
					if (oIndex <= this.rollIndex) {
						this.rollIndex--;
						if (this.rollIndex < 0) {
							this.rollIndex = 0;
						}
					}
					
					// 当前正在播放声音
					if (false && oIndex == this.audioIndex) {
						// 停止
						if(!this.$audio[0].paused){
							// flag audio roll
							this.audioRollFlag = false;
							this.$audio[0].pause();
						}
					}
					// 正在播放声音 或之前
					if (false && oIndex <= this.audioIndex) {
						this.audioIndex--;
					};
					
					// 移除当前val
					let delIndex = this.delKeys.indexOf(val);
					this.delKeys.splice(delIndex, 1);
				});
				
				// flag delekey
				this.delKeysFlag = false;
			},
			//========================== 报警数据改变 end ==========================
			
			/**
			 * @Des 当前时间
			 * @Auth
			 * @Date
			 */
			searchCurrentTime(t){
				// 清除计时器
				if (!this.$checkEmpty(this.timer_currentTime)) {
					clearTimeout(this.timer_currentTime);
					this.timer_currentTime = null;
				}
				
				// 空值 中止
				if (this.$checkEmpty(t)) {
					return false;
				}
				
				// 当前时间
				let date = new Date(t);// 当前时间
				let day = this.$moment(date).format('YYYY/M/D');// 年月日
				let week = this.$moment(date, 'YYYY/MM/DD').format('E');// 星期
				let time = this.$moment(date).format("HH:mm:ss");// 时分秒
				this.currentTime = day + " " + GlobalParam.weeks[week] + " " + time;
				
				return false;
				// 计时器
				this.timer_currentTime = setTimeout(() => {
					this.searchCurrentTime();
				}, 1000);
			},// searchCurrentTime
			
			//========================== 信息弹窗 轮播 start ==========================
			/**
			 * @Des 关闭信息弹窗
			 * @Auth
			 * @Date
			 */
			closeAllNotify() {
				// 关闭信息弹窗
				this.$notify.closeAll();
				// 记录notify
				this.notifyForm = {};
			},// closeAllNotify
			
			/**
			 * @Des 数据 数据记录
			 * @Auth
			 * @Date
			 */
			changeCordDate(data) {
				// get 0 time
				let date = new Date();
				date.setHours(0,0,0,0);
				let time = date.getTime();
				
				// 新 keys
				let newKeys = [];
				Object.assign([], data).forEach((row, index) => {
					// 空值 跳过
					if (this.$checkEmpty(row) || this.$checkEmpty(row.id)) return true;
					
					let formatT = '';
					if(new Date(row.alarmDate).getTime() - time < 0){
						formatT += 'YYYY-MM-DD';
					}
					formatT += ' HH:mm:ss';
					
					// msgText
					row.msgText = this.$moment(row.alarmDate).format(formatT) + ' ' + row.bindingName + ' 触发了 ' + row.alarmName;
					row.audioText = this.$moment(row.alarmDate).format(formatT) + row.bindingName + '触发了' + row.alarmName;
					
					// 新 keys
					newKeys.push(row.id);
					// 新数据
					if (this.cordKeys.indexOf(row.id) == -1) {
						// 记录数据
						this.cordList.push(Object.assign({}, row));
						// 记录数据 keys
						this.cordKeys.push(row.id);
					}
				});
				
				// 移除已取消信息
				Object.assign([], this.cordKeys).forEach((key, index) => {
					// 新数据中依旧存在 跳过
					if (newKeys.indexOf(key) > -1) return true;
					
					// 移除旧记录
					let oldIndex = this.cordKeys.indexOf(key);
					if (oldIndex > -1) {
						// 记录数据
						this.cordList.splice(oldIndex, 1);
						// 记录数据 keys
						this.cordKeys.splice(oldIndex, 1);
						
						// 移除旧弹窗
						let nIndex = this.notifyKeys.indexOf(key);
						if (nIndex > -1) {
							// notify list
							this.notifyList.splice(nIndex, 1);
							// notify keys
							this.notifyKeys.splice(nIndex, 1);
							
							// 记录notify
							if (this.notifyForm.hasOwnProperty(key)) {
								// 关闭弹窗
								this.notifyForm[key].close();
								delete this.notifyForm[key];
							}
						}
						
						// 移除 当前轮播项
						if (oldIndex == this.firstNotifyIndex) {
							// 停止
							if(!this.$audio[0].paused){
								this.$audio[0].pause();
							}
						}
						
						// 移除 轮播之前项
						if (oldIndex < this.firstNotifyIndex) {
							// 信息弹窗 index
							this.firstNotifyIndex--;
						}
					}
					
				});// 移除已取消信息
				
				// 初始化 消息弹窗轮播
				this.initNotifyRoll();
			},// changeNotifyDate
			
			/**
			 * @Des 初始化 消息弹窗轮播
			 * @Auth
			 * @Date
			 */
			initNotifyRoll() {
				
				// 记录数据
				const cordListL = this.cordList.length;
				const cordList = Object.assign([], this.cordList);
				// notify list
				const notifyListL = this.notifyList.length;
				
				// 清除计时器
				if (this.timer_init_notify != null) {
					clearInterval(this.timer_init_notify);
					// timer 初始化
					this.timer_init_notify = null;
				}
				
				let i = this.firstNotifyIndex + notifyListL;
				// timer 初始化
				this.timer_init_notify = setInterval(() => {
					if (i >= this.firstNotifyIndex + this.maxNotifyNUm) {
						clearInterval(this.timer_init_notify);
						// timer 初始化
						this.timer_init_notify = null;
						
						// 轮播 消息弹窗
						this.rollNotify();
						return false;
					}
					
					// 已展示全部
					if (this.notifyList.length >= cordListL) {
						clearInterval(this.timer_init_notify);
						// timer 初始化
						this.timer_init_notify = null;
						
						// 轮播 消息弹窗
						this.rollNotify();
					};
					
					let ci = i < cordListL ? i : (i%cordListL);
					let row = Object.assign({}, cordList[ci]);
					
					// 空值 中止
					if (this.$checkEmpty(row)) {
						i++;
						return false;
					}
					
					// 未展示
					if (this.notifyKeys.indexOf(row.id) == -1) {
						// notify list
						this.notifyList.push(row);
						// notify keys
						this.notifyKeys.push(row.id);
						
						// 弹窗
						
						// 首页 展示
						if (this.$anchorBox.is(':visible')) {
							// 记录notify
							this.notifyForm[row.id] = this.$notify({
								title: '警告（'+ (ci + 1) + '/' + cordListL +'）',
								message: row.msgText,
								type: 'warning',
								position: 'bottom-right',
								showClose: false,
								duration: 0,
								customClass: 'notify-mine-message',
							});
						}
					}
					
					i++;
					
				}, 400);
				
			},// initNotifyRoll
			/**
			 * @Des 初始化 消息弹窗轮播 重新
			 * @Auth
			 * @Date
			 */
			initNotifyRollAge() {
				
				// 记录数据
				const cordListL = this.cordList.length;
				const cordList = Object.assign([], this.cordList);
				// notify list
				const notifyListL = this.notifyList.length;
				
				// 清除计时器
				if (this.timer_init_notify != null) {
					// 正在初始化 跳过
					return false;
				}
				
				let i = 0;
				// timer 初始化
				this.timer_init_notify = setInterval(() => {
					if (i >= notifyListL) {
						clearInterval(this.timer_init_notify);
						// timer 初始化
						this.timer_init_notify = null;
						
						// 轮播 消息弹窗
						this.rollNotify();
						return false;
					}
					
					let ci = (i + this.firstNotifyIndex) < cordListL ? (i + this.firstNotifyIndex) : ((i + this.firstNotifyIndex)%cordListL);
					let row = Object.assign({}, cordList[ci]);
					
					// 首页 展示
					if (this.$anchorBox.is(':visible') && !this.notifyForm.hasOwnProperty(row.id)) {
						// 记录notify
						this.notifyForm[row.id] = this.$notify({
							title: '警告（'+ (ci + 1) + '/' + cordListL +'）',
							message: row.msgText,
							type: 'warning',
							position: 'bottom-right',
							showClose: false,
							duration: 0,
							customClass: 'notify-mine-message',
						});
					}
					
					i++;
					
				}, 400);
				
			},// initNotifyRoll
			
			/**
			 * @Des 轮播 消息弹窗
			 * @Auth
			 * @Date
			 */
			rollNotify() {
				
				// timer 轮播 notify
				if (this.timer_notify != null) {
					clearTimeout(this.timer_notify);
					this.timer_notify = null;
				}
				
				// 空值 中止
				if (this.notifyList.length <= 0) {
					// 停止
					if(!this.$audio[0].paused){
						this.$audio[0].pause();
					}
					// 关闭信息弹窗
					this.closeAllNotify();
					// 信息弹窗 index
					this.firstNotifyIndex = 0;
					return false;
				}
				
				// flag 允许播放声音
				if (!this.voiceAllowFlag) {
					
					// timer 轮播 notify
					this.timer_notify = setTimeout(() => {
						// 下一个 消息弹窗
						this.nextNotify();
					}, this.outTime_notify);
					
					return false;
				};
				
				// 信息弹窗 index
				const row = Object.assign({}, this.cordList[this.firstNotifyIndex%this.cordList.length]); 
				
				// 空值 && 已经请求过 中止
				if (this.$checkEmpty(row.audioSrc)) {
					
					// 文字换换语音
					this.textToVoice_notify();
					
					return false;
				}
				
				// 重置 src
				this.$audio.prop({'loop': false, 'muted': false}).attr({'src': row.audioSrc, 'cord_src': row.audioSrc});
				
				// 事件监听 audio 播放完毕
				this.$audio.off('ended').on('ended', () => {
					// timer 轮播 notify
					if (this.timer_notify != null) {
						clearTimeout(this.timer_notify);
						this.timer_notify = null;
					}
					
					// 下一个 消息弹窗
					this.nextNotify();
				});
				
				// 监听出错
				this.$audio.off('error').on('error', () => {
					// timer 轮播 notify
					if (this.timer_notify != null) {
						clearTimeout(this.timer_notify);
						this.timer_notify = null;
					}
					
					// timer 轮播 notify
					this.timer_notify = setTimeout(() => {
						
						// 下一个 消息弹窗
						this.nextNotify();
						
					}, this.outTime_notify);
				});
				
				// 静音
				this.$audio[0].muted = true;
				// 加载
				this.$audio[0].load();
				// 播放
				this.$audio[0].play();
				// 静音
				this.$audio[0].muted = false;
				
			},// rollNotify
			/**
			 * @Des 下一个 消息弹窗
			 * @Auth
			 * @Date
			 */
			nextNotify() {
				// 空值 中止
				if (this.notifyList.length <= 0) {
					// 停止
					if(!this.$audio[0].paused){
						this.$audio[0].pause();
					}
					// 关闭信息弹窗
					this.closeAllNotify();
					
					// 信息弹窗 index
					this.firstNotifyIndex = 0;
					return false;
				}
				
				// 移除第一个
				
				const key = this.notifyKeys[0];
				const notifyListLength = this.notifyList.length;
				
				if (this.notifyForm.hasOwnProperty(key)) {
					this.notifyForm[key].close();
					delete this.notifyForm[key];
				}
				
				// notify list
				this.notifyList.splice(0, 1);
				// notify keys
				this.notifyKeys.splice(0, 1);
				
				// 补充一个
				
				// 信息弹窗 index
				this.firstNotifyIndex++;
				// 限制
				if (this.firstNotifyIndex >= this.cordList.length) {
					// 信息弹窗 index
					this.firstNotifyIndex = 0;
				}
				
				let currIndex = (this.firstNotifyIndex + notifyListLength - 1) < this.cordList.length ? (this.firstNotifyIndex + notifyListLength - 1) : ((this.firstNotifyIndex + notifyListLength - 1) % this.cordList.length);
				// 记录数据
				let row = Object.assign({}, this.cordList[currIndex]);
				
				// 空值 中止
				if (this.$checkEmpty(row)) return false;
				
				// notify list
				this.notifyList.push(row);
				// notify keys
				this.notifyKeys.push(row.id);
				
				// 首页展示
				if (this.$anchorBox.is(':visible')) {
					// 记录notify
					this.notifyForm[row.id] = this.$notify({
						title: '警告（'+ (currIndex + 1) + '/' + this.cordList.length +'）',
						message: row.msgText,
						type: 'warning',
						position: 'bottom-right',
						showClose: false,
						duration: 0,
						customClass: 'notify-mine-message',
					});
				}
				
				// 轮播 消息弹窗
				this.rollNotify();
				
			},// changeNotify
			
			/**
			 * @Des 文字换换语音
			 * @Auth 
			 * @Date 
			 */
			textToVoice_notify() {
				
				// flag 允许播放声音
				if (!this.voiceAllowFlag) {
					// timer 轮播 notify
					this.timer_notify = setTimeout(() => {
						// 下一个 消息弹窗
						this.nextNotify();
					}, this.outTime_notify);
					return false;
				}
				
				// 信息弹窗 index
				if (this.firstNotifyIndex < 0) {
					// 信息弹窗 index
					this.firstNotifyIndex = 0;
				}
				
				// 记录数据
				const row_record = Object.assign({}, this.cordList[this.firstNotifyIndex]);
				
				// 有语音 继续播放
				if (!this.$checkEmpty(row_record.audioSrc)) {
					// timer 轮播 notify
					if (this.timer_notify != null) {
						clearTimeout(this.timer_notify);
						this.timer_notify = null;
					}
					
					// 轮播 消息弹窗
					this.rollNotify();
					
					return false;
				}
				
				// 设置 apiKey
				this.$store.state.apiKey = '467da6edce4e831998edc7d9b7e215bfWN';
				this.$request.postJsonRequest(ApiOam.Text_To_Voice_Uri, {
					projectId: this.$store.state.currentProjectId,
					text: row_record.audioText
				}).then(result => {
					
					// timer 轮播 notify
					if (this.timer_notify != null) {
						clearTimeout(this.timer_notify);
						this.timer_notify = null;
					}
					
					// 数据对应 更改 audioSrc
					if (!this.$checkEmpty(this.cordList[this.firstNotifyIndex]) && this.cordList[this.firstNotifyIndex].audioText == row_record.audioText) {
						this.cordList[this.firstNotifyIndex].audioSrc = "data:audio/wav;base64," + result.data;
						// flag 向后台交互
						this.cordList[this.firstNotifyIndex].getVoiceFlag = true;
					}
					
					
					// 设置 apiKey
					this.$store.state.apiKey = '';
					
					// 轮播 消息弹窗
					this.rollNotify();
					
				}).catch(error => {
					// 设置 apiKey
					this.$store.state.apiKey = '';
					
					// timer 轮播 notify
					if (this.timer_notify != null) {
						clearTimeout(this.timer_notify);
						this.timer_notify = null;
					}
					
					// 数据对应 更改 audioSrc
					if (!this.$checkEmpty(this.cordList[this.firstNotifyIndex]) && this.cordList[this.firstNotifyIndex].audioText == row_record.audioText) {
						// flag 向后台交互
						this.cordList[this.firstNotifyIndex].getVoiceFlag = true;
					}
					
					// timer 轮播 notify
					this.timer_notify = setTimeout(() => {
						// 下一个 消息弹窗
						this.nextNotify();
					}, this.outTime_notify);
					
					console.error('文字转语音异常', ApiOam.Text_To_Voice_Uri, error);
				})
			},// textToVoice_notify
			
			//========================== 信息弹窗 轮播 end ==========================
			
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_index/AppMessage/Messages.vue